<template>
  <v-hover v-if="ticket">
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2} cursor-pointer`"
      @click.stop="goToTicketOverview(ticket.id)"
      height="100%"
      style="overflow: auto"
    >
      <!-- Purchased mark -->
      <v-tooltip v-if="hasGroupTicketPurchased(ticket.id)" top color="primary">
        <template v-slot:activator="{ on }">
          <v-chip
            v-on="on"
            label
            small
            color="success"
            :class="[$vuetify.rtl ? 'rotate45deg-rtl' : 'rotate45deg-ltr']"
          >
            {{ $t("screener.purchased.title") }}
          </v-chip>
        </template>

        <span class="background--text text--darken-3 body-1">
          {{ $t("screener.purchased.group_ticket.tooltip") }}
        </span>
      </v-tooltip>

      <v-card-text class="text-xs-center pa-3">
        <h2 class="primary--text">{{ ticket.name }}</h2>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="text-xs-center">
        <div class="secondary--text">
          <span class="title px-1">{{
            getCurrencySymbol(ticket.currency)
          }}</span>
          <span class="display-2">{{ ticket.price }}</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="subheading secondary--text">
        <div>
          {{ ticket.description }}
        </div>
        <ul class="px-3 py-2">
          <li>
            {{
              $t("screener.monetization.group_ticket.contains_screenings", {
                number_of_screening: ticket.screening_ids.length
              })
            }}
          </li>
          <li>
            {{
              $t("screener.monetization.group_ticket.valid_till", {
                end_date: moment
                  .utc(ticket.purchasing_end_date)
                  .local()
                  .format("lll")
              })
            }}
          </li>
        </ul>
        <div class="subheading mt-1">
          <router-link
            class="blue--text"
            :to="{
              name: 'pricing.overview',
              params: {
                pricing_id: ticket.id
              }
            }"
            >{{ $t("screener.view_detail.title") }}</router-link
          >
        </div>
      </v-card-text>
      <v-card-text class="pt-0 text-xs-center">
        <v-btn
          v-if="!hasGroupTicketPurchased(ticket.id) && !hasGroupTicketPaymentInProcess(ticket.id)"
          dark
          color="primary background--text"
          @click.stop="$emit('onBuyTicket', ticket)"
          >{{ $t("screener.btn.buy_pass") }}</v-btn
        >
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { currencySymbol } from "@/mixins/currencySymbol";
import { hasGroupTicketPurchased , hasGroupTicketPaymentInProcess } from "@/mixins/monetization";

// Props
const props = {
  ticket: {
    type: Object,
    default: null
  }
};

// Mixins
const mixins = [currencySymbol, hasGroupTicketPurchased, hasGroupTicketPaymentInProcess];

// Methods
const methods = {
  goToTicketOverview(pricing_id) {
    this.$router.push({
      name: "pricing.overview",
      params: {
        pricing_id: pricing_id
      }
    });
  }
};

export default {
  props: props,
  mixins: mixins,
  methods: methods,
  computed:{
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
  }
};
</script>

<style scoped>
>>> .v-chip__content {
  width: 115px;
  text-align: center;
  justify-content: center;
}
</style>
